import modals from './modals';
import stageLanguage from './stage-language';

const SITE_AJAX_URL = typeof window.siteAjaxUrl !== 'undefined' ? window.siteAjaxUrl : '/stage-ajax/';
const LANGUAGE = stageLanguage; //typeof window.stage_language !== 'undefined' ? window.stage_language : window.location.href.split('/')[3];

/**
 * AjaxForm handle communication between Stage and form's Frontside code. Handle tokens and data logic.
 * This is code is just a refactored version from the older Ajaxform code.. so there might be a small issues.
 */
class AjaxForm {

  /**
   * @constructor
   * @param {HTMLFormElement} form context where instance of class works on.
   */
  constructor(form) {

    this.dom = {
      form,
      submitButton: form.querySelector('button[type="submit"]')
    }

    this.addEventListener();
  }

  /**
   * Here we add event listeners to form and it's elements.
   */
  addEventListener() {
    this.dom.form.addEventListener('submit', (event) => {
      event.preventDefault();
      this.postFormToTarget(this.dom.form.name,
        this.dom.form.dataset.targetUrl,
        this.dom.form.dataset.category,
        this.dom.form.dataset.formNameExtension);
    });
  }

  /**
   * Set loading state. States are 'loading' or 'waiting'.
   * @param {string} state state
   */
  setLoadingState(state) {
    if( this.dom.submitButton ) {
      this.dom.submitButton.disabled = state === 'loading';
      this.dom.submitButton.classList.toggle('show-spinner', state === 'loading')
    }
  }

  /**
   * Send form's data to Stage
   * @param {string} formName form ID
   * @param {string} targetUrl target URL address
   * @param {string} formCategory form category, not in use
   * @param {string} formNameExtension form name extension?, not in use
   */
  postFormToTarget(formName, targetUrl, formCategory, formNameExtension = '') {

    const form = document.forms[formName];//This could be replaced by this.dom.form
    const useFormData = 'useFormData' in form.dataset;
    const isRedirect = 'redirectUrl' in form.dataset;

    this.setLoadingState('loading');

    this.request('GET', SITE_AJAX_URL + 'get-token?stage-language=' + LANGUAGE)
      .then((e) => { return JSON.parse(e.target.response); })
      .then((data) => {
        let body;

        if (useFormData) {
          body = new FormData(form);
          body.append('token', data.token);

          const separatedFiles = this.separateMultipleFiles(form);

          if (separatedFiles && separatedFiles.length) {
            separatedFiles.forEach(file => {
              body.append(file.name, file.value);
            });
          }
        }
        else {
          const formJson = this.formToJSON(form);
          formJson.token = data.token;
          body = JSON.stringify(formJson);
        }

        if (!this.working) {
          this.working = true;

          this.request('POST', SITE_AJAX_URL + targetUrl + '?stage-language=' + LANGUAGE, body)
            .then((e) => { return JSON.parse(e.target.response); })
            .then((data) => {
              this.displayMessage(formName, data, isRedirect);

              if (data.invalidFields) {
                this.highlightFields(form, data.invalidFields);
              }

              if (data.success) {
                form.dispatchEvent(new Event('ajax-success'));
                form.reset();

                if (typeof window.multiselects === 'object' && window.multiselects !== null) { // If multiselects on current page
                  Object.keys(window.multiselects)
                    .filter(multiselect => window.multiselects[multiselect].element.form === form) // Get multiselects that belong to current form
                    .forEach(multiselect => window.multiselects[multiselect].unSelectAll()); // Unselect matching multiselects
                }

                if (isRedirect) {
                  window.location.replace(form.dataset.redirectUrl);
                }
              }

              this.working = false;

              this.setLoadingState('waiting');
            })
        }
      });
  }

  /**
   * Read data from form's element to a plain object
   * @param {HTMLFormElement} form - form element to read data from
   * @returns {object}
   */
  formToJSON(form) {
    const json = {};
    for (const element of form.elements) {
      // Handle multiselect dropdowns
      if (element.tagName.toLowerCase() === 'select' && element.multiple) {
        const selectedOptions = Array.from(element.options).filter(option => option.selected);
        json[element.name] = selectedOptions.filter(option => option.value).map(option => option.value);
        continue;
      }
      // Handle everything else
      if ((element.tagName.toLowerCase() !== 'button' && element.type !== 'button') &&
        (element.type !== 'radio' && element.type !== 'checkbox' || element.checked)) {
        json[element.name] = element.value;
      }
    }
    return json;
  }

  /**
   * Display message on form
   * @param {string} formName form ID
   * @param {object} data message data
   * @param {boolean} isRedirect some form are just a redirect links to other pages, example "Huollon varaus"?
   */
  displayMessage(formName, data, isRedirect) {
    const form           = document.getElementsByName(formName)[0],
      resultMessages     = document.getElementsByClassName('result-message'),
      callbackCloseModal = form.dataset.callbackCloseModal;

    for (const message of resultMessages) {
      if (message.dataset.form === formName) {
        message.innerHTML = data.message;

        if (isRedirect) {
          if (data.success) {
            message.classList.remove('error');
            message.classList.remove('show');
          }
          else {
            message.classList.add('error');
            message.classList.add('show');
          }
        }
        else {
          if (data.success) {
            form.classList.add('hidden');
          }
          else {
            message.classList.add('error');
          }

          message.classList.add('show');

          setTimeout(function () {
            form.classList.remove('hidden');
            message.classList.remove('error');
            message.classList.remove('show');

            if (data.success && callbackCloseModal && callbackCloseModal.length) {
              modals.closeModal(callbackCloseModal);
            }
          }, 5000);
        }
      }
    }
  }

  /**
   * Highlight fields
   * @param {HTMLFormElement} form form
   * @param {HTMLElement[]} fields form's fields
   */
  highlightFields(form, fields) {
    for (const element of form.elements) {
      const label = form.querySelector(`label[for="${element.id}"]`);

      if (fields.includes(element.name)) {
        element.classList.add('invalid-field');
        label.classList.add('error');
      }
      else if (element.classList.contains('invalid-child')) {
        element.classList.remove('invalid-field');
        label.classList.remove('error');
      }
    }
  }

  /**
   * Send
   * @param {string} method request method
   * @param {string} url request url
   * @param {string} body request body, example stringified JSON "JSON.stringify(body)"
   * @returns {Promise} Promise is resolved http request HTTP-status code is 2xx or rejected on failure if response code is 4xx or 5xx.
   */
  request(method, url, body = null) {
    return new Promise((resolve, reject) => {
      var xhr = new XMLHttpRequest();
      xhr.open(method, url);
      //xhr.onprogress = () => {};
      xhr.onload = resolve;
      xhr.onerror = reject;
      xhr.send(body);
    });
  }

  /**
   * Convert form's file object to file array
   * @param {HTMLFormElement} form form element
   * @returns {object[]}
   */
  separateMultipleFiles(form) {
    const multiFileInputs = form.querySelectorAll('input[type="file"][multiple]');

    if (!multiFileInputs || !multiFileInputs.length) {
      return false;
    }

    const separatedFiles = [];

    Array.from(multiFileInputs).forEach(input => {
      const fileKeys = Object.keys(input.files);

      if (fileKeys && fileKeys.length) {
        fileKeys.forEach((key, index) => {
          separatedFiles.push({
            name: input.name + index,
            value: input.files[key]
          });
        });
      }
    });

    return separatedFiles;
  }

  /**
   * Initialize AjaxForms
   */
  static init() {
    const ajaxForms = document.querySelectorAll('.ajax-form');

    for (const form of ajaxForms) {
      new AjaxForm( form );
    }
  }
}

export default AjaxForm;
